import dayjs from 'dayjs';

const JP = {
  header: {
    Home: 'トップページです',
    News: '企業情報です',
    Manufacture: '金型製造です',
    Product: 'プレゼンテーションです',
    Mall: '模具商城',
    Platform: '接单平台',
    Contact: 'ビジネス提携です',
    Wechat: '公众号',
    TechnicalStrength: '技術力です',
    CustomerCase: '顧客事例です',
    moldCloud: '中型雲網です'
  },
  section: {
    introduce: {
      // companyName:'浙江中模精機有限公司です',
      companyName:'宁波大榭开发区天正模具有限公司',
      title: '会社紹介です',
      more:'もっと詳しく知ります',
      content: '寧波大榭開発区天正金型有限公司は、中国浙江省寧波市の国家級大榭経済開発区に位置し、2000年に創立しました。会社は創業以来、技術、堅固な品質に特化し、長年にわたり、ダイカスト金型の設計と製造に専念しています。弊社の設計、開発、製作した金型は主に国内外の大手メーカー向けで、自働車部品、医療机器、照明システム、通信製品などの分野に及び、全国、日本、北米、ヨーロッパに販売しています。'
    },
    products:{
      title:'プレゼンテーションです',
      subtitle:'COMPANY PRODUCTS',
      more: '詳細を調べます。'
    },
    // honor: '企业荣誉',
    honor: {
      title:'企業の名誉です',
      more: 'もっと詳しく知ります',
      articleTitle:'国家レベルの「小さな巨人」企業に特化しています',
      content:'品質立業、善鋳精誠、寧波天正型有限会社は絶えずの革新と堅守で、リーンの標棒を定義して、絶えずの展開と変化の中で、鋳鋳民のブランドの強い背骨です。 | 天正金型は、国家レベルの専門性と新しい「小さな巨人」企業として、国内の大規模なマグネシウム合金構造ダイカスト金型のリーダー企業であり、大規模なマグネシウム合金金型の設計、製造および鋳物生産プロセスのコア技術を持って、金型の全ライフサイクルの管理サービス能力を持っています。'
    },
    tags:{
      win:'協力はウィンウィンです',
      benefitingAll:'天下に恵んで参ります',
      honesty:'誠実で信用を守る',
      brandValue:'ブランド価値です'
    },
    qrTips:'扫码关注公众号',
    partner: {
      title: '主要取引先です',
      firstRow: '丰田 | 通用 | 海拉',
      secondRow: '众泰 | 本田 | 福特',
      thirdRow: '标致 | 爱信 | 水星',
      fourRow: '保时捷 | 比亚迪 | 飞利浦',
      fifthRow: '上汽 | 日本电产',
    },
    culture: '企業文化です',
    newsBlock: {
      more: 'もっと調べます',
      title: '企業情報です'
    },
    poster: {
      title: '中国です'
    },
    CustomerCase: {
      title: '顧客事例です',
      more: 'もっと詳しく知ります'
    }
  },
  footer: {
    blockTitles:{
      // about:'关于天正',
      // moldManufacturing:'模具制造',
      // friendlyLinks:'友情链接',
      // contactInformation:'联系方式'
      about:'关于天正',
      moldManufacturing:'金型製造です',
      friendlyLinks:'友情のリンクです',
      contactInformation:'連絡先です'
    },
    technology:'技術開発です',
    quality:'品質保証です',
    deviceSupport:'デバイスサポートです',
    home: '家です',
    contact: '連絡してきます',
    molds: '模具商城',
    order: '接单平台',
    mail: '会社のメールです',
    business: '会社の業務',
    license: '営業許可証です',
    wx: '公式wechatです',
    phone: '電話です: ',
    fax: 'ファックスです: ',
    mailbox: 'メールボックスです: ',
    website: 'ウェブサイトです: http://www.tzmc.com',
    record: '备案号 ',
    copyright: `©${dayjs().year()} 天正模具有限公司 版权所有`,
    news: 'ニュース情報です',
    product: 'プレゼンテーションです',
    customerCase: '顧客事例です',
    power: '技術力です',
    moldCloud: '中型雲網です'
  },
  manufacture: {
    title: '金型製造です',
    subtitle: '技术研发 | 质量保证 | 设备支持 | 系统支持',
    crumbs: '您现在的位置',
    technology: '当社は国内外のトップクラスのダイキャスト技術と金型製造の研究開発技術者を集め、堅実で安定した人材構成を持ち、結束力があり効率的なチームを形成しています。当社は複数の設計・開発センターを設立し、金型の開発設計から生産出荷まで、全工程にわたる科学的で効果的な製造サービスを提供しています。現在、海外エンジニアを含む30名以上の開発設計および技術スタッフを擁しており、堅実で安定した人材基盤が金型の設計やユーザーの使用・保守に信頼性をもたらしています。',
    quality: '以质量求生存，以效率求发展，天正模具配备了一整套国际一流的精密模具加工设备，进口的微米级高速加工中心，可以满足客户对模具最苛刻的精度要求，高精度激光扫描三坐标测量仪，对模具进行全面检测，确保天正出品的每一套模具达到精工品质。',
    equipment: '多年的模具生产经验，公司已梳理、完善了一套符合“TZMC” 特色模具制造和管理需求的工作流程，使每一套模具制造都具有最佳的工艺路线和作业指导书。天正模具配备了一整套国际一流的精密模具加工设备，进口的微米级高速加工中心，可以满足客户对模具最苛刻的精度要求。',
    system: '天正模具引入E-MAN生产管理系统和APS排产系统，实现生产管理信息化、精细化、流程化，缩短模具生产周期，增强成本管理能力。',
    team: {
      title: '品質保証研究開発チーム',
      content: '当社は国内外のトップクラスのダイキャスト技術と金型製造の研究開発技術者を集め、堅実で安定した人材構成を持ち、結束力があり効率的なチームを形成しています。当社は複数の設計・開発センターを設立し、金型の開発設計から生産出荷まで、全工程にわたる科学的で効果的な製造サービスを提供しています。現在、海外エンジニアを含む40名以上の開発設計および技術スタッフを擁しており、堅実で安定した人材基盤が金型の設計やユーザーの使用・保守に信頼性をもたらしています。',
      technicalPersonnel: '技術者',
      undergraduateDegree: '学士学位',
      developmentCenter: '設計研究開発センター',
      GenuineDesignSoftware: '正規版デザインソフトウェア'
    },
    patent: {
      companyName: 'T·Z·M·C',
      slogan: '品質は基を築いて、特許は先導して、栄誉は証人です',
      subSlogan: 'Quality Lays the Foundation, Patents Lead the Way, Honors Bear Witness'
    },
    equipments: {
      title: '高精度設備による高品質製品',
      content: '天正模具は品質と効率を核心とし、国際的に一流の精密金型加工設備と輸入されたマイクロメートル級の高速加工センタを備えています。これにより、お客様の金型に対する高精度な要求を満たすことができます。また、高精度レーザースキャニング三次元測定器を導入して全面的な検査を行い、すべての金型が精密な品質を達成することを確実にします。長年の生産経験により、自社の特色に合った一連の作業フローが形成され、金型製造に最適な工程と作業指示書が提供されています。',
      MeasuringInstrument: '高精度レーザースキャニング三座標測定機',
      MachiningCenter: 'マイクロメートル級高速加工センター'
    },
    systems: {
      title: '天正金型はE-MAN生産管理システムとAPSスケジューリングシステムを導入しました',
      ProductionManagement: {
        title: '生産管理"',
        desc: '情報の統合と可視化を行い、生産管理の情報化、精細化、プロセス化を実現します。'
      },

      ProductionCycle: {
        title: '生産サイクル',
        desc: '生産計画の最適化、生産進捗のリアルタイム監視により、金型生産サイクルの短縮を図ります。'
      },

      ManagementCosts: {
        title: '管理コスト',
        desc: '生産フローの最適化により損失を削減し、生産バッチの合理的な配置により固定費を低下させます。'
      }
    }
  },
  contact: {
    title: '業務連絡です',
    business: {
      title: '業務連絡です',
      domestic: '国内です',
      international: 'インターナショナルです'
    },
    technology: {
      title: '技術的なつながりです',
      Daxie: '大榭技術部です',
      Beilun: '北侖技術部です'
    },
    location: '浙江省寧波市大榭開発区北渡路5号です',
    tab: {
      business: 'ビジネス提携です',
      job: '人材募集です'
    },
    job: {
      title: '仕事を募集します。',
      SocialRecruitment: '社会人採用です',
      CampusRecruitment: 'キャンパス採用',
      search: '職務検索です',
      Duty: '持ち場の職責',
      JobRequirements: '役職要求です',
      TreatmentAndWelfare: '福利厚生です。',
      numberRecruitsUnit: '人',
      resume: '履歴書を送ります',
      uploadResume: '履歴書をアップします',
      cancel: '取り消します',
      confirm: 'アップロードします ',
      uploadFail: 'アップロード失敗しました',
      uploadSuccess: 'アップロード成功です',
      emptyDesc: 'データがない'
    },
    contact: {
      phone: '電話です',
      fax: 'ファックスです',
      email: 'メールボックスです',
      address: 'アドレスです'
    }
  },
  content:{
    News: 'プレスセンターです',
    Company: '会社のニュースです',
    Industry: '業界情報です',
    More: 'もっとです',
    NewsCenter: 'プレスセンターです',
    Location: '您现在的位置',
    All: '全部',
    Productdisplay: 'プレゼンテーションです',
    Molds: '金型展示です',
    Products: 'プレゼンテーションです',
    Mold: '金型',
    Schimmel: '金型',
    Parts: '自動車部品です',
    Machinery: '汎用機械です',
    Other: 'その他です',
    TechnicalStrength: '技術力です'
  },
  news: {
    createTime: 'この記事の作成時間です：'
  },
  companyDesc: {
    FoundingDate: '成立時期です',
    Employees: '会社の社員です',
    Customer: '戦略的提携パートナーです',
    FoundingDateUnit: 'ねんです'
  },
  notFound: {
    message: '訪問したページは存在しません',
    tips: 'ご入力いただいたurlが正しいか確認するか、下記のボタンをクリックしてホーム画面に戻ります。',
    backHome: 'ホームページに戻ります'
  },
  customerService: '顧客サービスです'
}


export default JP